<template>
  <div id="page-forms">
    <div class="sub-titulo">
      <v-subheader class="sub-titu">
        - Proveedor: {{ nombreProveedor }}, Contrato: {{ codContrato }},
        Período: {{ perContrato }}</v-subheader
      >
    </div>
    <grupo-procesos
      :idContrato="contratoId"
      :proceso="proceso"
    ></grupo-procesos>
    <v-layout align-center justify-center>
      <v-flex lg12>
        <!-- TABLA DOCUMENTO -->
        <template>
          <div v-if="loading">
            <loading></loading>
          </div>
          <v-tabs v-model="active_tab">
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE PROVEEDOR -->
              <v-card flat v-if="tabSelected == 'Proveedor'">
                <proveedor-tab
                  :show="true"
                  :tipeView="'consulta'"
                  :contratoId="contratoId"
                ></proveedor-tab>
              </v-card>
              <!-- TAB DE MATRICES -->
              <v-card flat v-if="tabSelected == 'Matrices'">
                <matrices-tab-captura
                  :contratoId="contratoId"
                ></matrices-tab-captura>
              </v-card>
              <!-- TAB DE PROCESO -->
              <v-card flat v-if="tabSelected == 'Proceso'">
                <proceso-tab-captura
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></proceso-tab-captura>
              </v-card>
              <!-- TAB PANEL DE CONTROL -->
              <v-card flat v-if="tabSelected == 'Panel de control'">
                <panel-control-tab
                  show="true"
                  :idContrato="contratoId"
                ></panel-control-tab>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
        <!-- TABLA DOCUMENTO -->
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ProveedorTab from "@/modules/configuration/commonsviews/ProveedorTab.vue";
import ProcesoTabCaptura from "@/modules/captura/views/proceso/ProcesoTabCaptura.vue";
import MatricesTabCaptura from "@/modules/captura/views/proceso/MatricesTabCaptura.vue";
import PanelControlTab from "@/modules/configuration/contrato/PanelControlTab.vue";
import Loading from "@/views/ui/Loading.vue";
import GrupoProcesos from "@/components/GrupoProcesos.vue";

export default {
  name: "proceso-captura",

  components: {
    ProveedorTab,
    ProcesoTabCaptura,
    MatricesTabCaptura,
    Loading,
    PanelControlTab,
    GrupoProcesos,
  },

  props: {},

  data() {
    return {
      tabSelected: "",
      loading: false,
      contratoId: 0,
      proceso: "",
      tabs: ["Proveedor", "Proceso"],
      index: "",
      nombreProveedor: "",
      codContrato: "",
      perContrato: "",
    };
  },

  mounted() {},
  created() {
    this.proceso = this.$store.getters.proSelectedStored;
    this.contratoId = Number(this.$route.params.contratoId);
    this.nombreProveedor = this.$store.getters.nombreProveedorStored;
    this.codContrato = this.$store.getters.contratoCodStored;
    this.perContrato = this.$store.getters.contratoPerStored;
    this.loadSelected();

    if (this.$store.getters.userLogged.tipo != "PROVEEDOR") {
      this.tabs = ["Proveedor", "Matrices", "Proceso"];
    }
    if (this.$store.getters.userLogged.tipo == "ADMINISTRADOR") {
      this.tabs.push("Panel de control");
    }
    this.active_tab = this.tabs.indexOf(this.$store.getters.tabSelectedStored);
  },

  methods: {
    loadSelected() {
      this.tabSelected = this.$store.getters.tabSelectedStored;
    },
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_pro_tab_state", "");
      this.$store.commit("sub_tab_state", "");
    },
  },
};
</script>
